<template>
    <div class="modal fade" ref="addAccountModal" id="addAccountModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <PaymentMethod :paymentMethodList="paymentMethodList"></PaymentMethod>
        </div>
    </div>
</template>
<script >
import { defineAsyncComponent } from 'vue';
import PaymentMethod from './PaymentMethod.vue';
export default {
     props: ['paymentMethodList'],
    components: {
        PaymentMethod
    },
}
</script>